<template>
  <section class="flex flex-col items-start gap-4 self-stretch">
    <section class="flex w-[548px] flex-col items-start gap-2 self-stretch">
      <UITextSmMedium>{{ t("common.integratePopup.share.shareViaSocials") }}</UITextSmMedium>
      <div class="flex items-start gap-3 self-stretch">
        <a
          class="flex items-center gap-2 rounded-lg border border-[#EAECF0] bg-white p-4"
          :href="pathToSocialMedia('facebook')"
          target="_blank"
        >
          <FacebookIcon class="h-6 w-6"></FacebookIcon>
        </a>
        <a
          class="flex items-center gap-2 rounded-lg border border-[#EAECF0] bg-white p-4"
          :href="pathToSocialMedia('whatsapp')"
          target="_blank"
        >
          <img src="@/assets/img/whatsappImage.png" class="h-6 w-6" />
        </a>
        <a
          class="flex items-center gap-2 rounded-lg border border-[#EAECF0] bg-white p-4"
          :href="pathToSocialMedia('linkedin')"
          target="_blank"
        >
          <LinkedlnIcon class="h-6 w-6"></LinkedlnIcon>
        </a>
        <a
          class="flex items-center gap-2 rounded-lg border border-[#EAECF0] bg-white p-4"
          :href="pathToSocialMedia('x')"
          target="_blank"
        >
          <XBrandIcon class="h-6 w-6"></XBrandIcon>
        </a>
      </div>
    </section>
    <section class="flex flex-col items-start gap-3 self-stretch">
      <UITextSmMedium>{{ t("common.integratePopup.share.copyLink") }}</UITextSmMedium>
      <UIInput id="copyCode" :readonly="true" size="large" :model-value="embedUrl">
        <template #suffix
          ><Copy01Icon class="h-5 w-5 cursor-pointer" :class="activeClass" @click="copyLink"
        /></template>
      </UIInput>
      <a :href="embedUrl" target="_blank">
        <UIButton id="openFormLink" type="tertiary" size="medium">
          <Share03Icon class="h-5 w-5"></Share03Icon>
          <div class="ml-2">{{ t(`${i18nPath}.share.openFormLink`) }}</div>
        </UIButton>
      </a>
    </section>
  </section>
</template>

<script setup lang="ts">
import FacebookIcon from "@/assets/icons/facebook.svg";
import LinkedlnIcon from "@/assets/icons/linkedln.svg";
import XBrandIcon from "@/assets/icons/x-brand.svg";
import { useAppStore } from "@/store/app";
import { sleep } from "@/util/methods";
import { Copy01Icon, Share03Icon } from "@gohighlevel/ghl-icons/24/outline";
import { UIButton, UIInput, UITextSmMedium } from "@gohighlevel/ghl-ui";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

const store = useAppStore();
const { t } = useI18n();

const props = defineProps({
  widgetName: {
    type: String,
    required: true,
  },
  widgetId: {
    type: String,
    required: true,
  },
  baseUrl: {
    type: String,
    required: true,
  },
});

const i18nPath = computed(() => {
  return store.formId
    ? "form.integratePopup"
    : store.surveyId
    ? "survey.integratePopup"
    : "quiz.integratePopup";
});

const embedUrl = ref();
const activeClass = ref("text-black-600");
if (process.env.NODE_ENV === "development") {
  embedUrl.value = `http://localhost:3344/widget/${props.widgetName}/${props.widgetId}`;
} else {
  embedUrl.value = props.baseUrl + `/widget/${props.widgetName}/${props.widgetId}`;
}

const copyLink = async () => {
  activeClass.value = "text-blue-600";
  store.copyToClipBoard(embedUrl.value);
  await sleep(6000);
  activeClass.value = "text-black-600";
};

const pathToSocialMedia = (type: string) => {
  switch (type) {
    case "facebook":
      return `https://www.facebook.com/sharer/sharer.php?u=${embedUrl.value}`;
    case "whatsapp":
      return `https://api.whatsapp.com/send?text=${embedUrl.value}`;
    case "linkedin":
      return `https://www.linkedin.com/shareArticle?mini=true&url=${embedUrl.value}`;
    case "x":
      return `https://twitter.com/intent/tweet?url=${embedUrl.value}`;
    default:
      return embedUrl.value;
  }
};
</script>
